( function(root, factory) {
    if ( typeof define === 'function' && define.amd) {
        // using AMD; register as anon module
        define('mmc.libs.jquery.mmcFileUploader',['jquery'], factory);
    } else {
        // no AMD; invoke directly
        factory(root.jQuery);
    }
}(this, function($) {
    $.fn.mmcFileUploader = function() {
        return $(this).each(function(){
            var $input, $uploader, $filename, updateInterval, defaultFilenameText, filename;
            var updateFilename = function() {
                filename = $input.val();
                if (filename === '') {
                    filename = defaultFilenameText;
                } else {
                    filename = filename.split(/[\/\\]+/);
                    filename = filename[(filename.length - 1)];
                }
                $filename.text(filename);
            };
            var updateClass = function() {
                if (filename !== '') {
                    $uploader.addClass('is-filled');
                } else {
                    $uploader.removeClass('is-filled');
                }
            };
            var updateImage = function() {
                // TODO: code image insertion
            };
            var update = function() {
                updateFilename();
                updateClass();
                updateImage();
            };
            var focus = function(){
                $uploader.addClass('focus');
                updateInterval = setInterval(update, 30);
            };
            var blur = function(){
                $uploader.removeClass('focus');
                clearInterval(updateInterval);
            };
            $uploader = $(this);
            $input = $uploader.find('input[type="file"]');
            $filename = $uploader.find('.file-uploader--filename');
            defaultFilenameText = $filename.text();
            $input.on('change', update);
            $input.on('focus', focus);
            $input.on('blur', blur);
            update();
        });
    };
}));

